import './ModalHeader.css'

interface ModalHeaderProps {
  title: string
  onClose: () => void
}

/** Title + `✕` row for a `ModalBackdrop` panel. The rivals modal,
 *  the avatar picker and the quest picker had three byte-identical copies of
 *  this geometry; this is the one copy they now share. GameweekDetail is
 *  deliberately not a consumer — its close button floats over the content
 *  rather than sitting in a title row. */
function ModalHeader({ title, onClose }: ModalHeaderProps) {
  return (
    <div className="modal-header">
      <p className="modal-header__title">{title}</p>
      <button
        type="button"
        className="modal-header__close"
        onClick={onClose}
        aria-label="Close"
      >
        ✕
      </button>
    </div>
  )
}

export default ModalHeader
